export enum Status {
	SUCCESS,
	FAILURE,
	UNSUPPORTED,
	UNAUTHORIZED,
	EXPIRED,
	UNKNOWN
}

enum ResolverType {
	COLOR,
	LITERAL,
	DATE,
}

interface IProperty<T extends ResolverType> {
	displayName: string;
	value: any;
	default?: boolean;
	resolver?: T;
}

interface IPropertyGroup {
	properties: IProperty<any>[];
	default: boolean;
}

export const DefaultProperties = {

	BRAND_PRIMARY: {
		displayName: "Brand Primary",
		value: "#333",
		default: true
	},
	BRAND_SECONDARY: {
		displayName: "Brand Secondary",
		value: "#000",
		default: true
	},
	BRAND_TERTIARY: {
		displayName: "Brand Secondary",
		value: "#000",
		default: true
	}

}

export const ExtensionType= {
	NEW_EXTENSION:"CreateNewSubscription",
	EXISTING_EXTENSION:"ExtendExistingSubscription"
}

function registerProperty(property: IProperty<any>) {
	console.log("registered: " + property.displayName);
}

Object.values(DefaultProperties).forEach((property: IProperty<any>) => {
	registerProperty(property);
});

// register the defaults!!!.



// WEBPACK FOOTER //
// ./src/common/constants/Constants.ts